import { Autocomplete, Chip, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

const CustomList = ({
  label,
  disabled = false,
  defaultValue = [],
  onChange = () => {},
  title = "",
}) => {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    let updated = [...defaultValue];
    if (defaultValue?.length > 0 && defaultValue[0]?.name) {
      updated = defaultValue.map((obj) => obj.name);
    }
    setTags(updated);
  }, [defaultValue]);

  const handleChange = (value) => {
    setTags(value);
    onChange(value);
  };

  return (
    <Autocomplete
      title={title}
      limitTags={2}
      multiple
      disabled={disabled}
      value={tags}
      onChange={(e, value) => handleChange(value)}
      options={[]}
      freeSolo
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip key={index} label={option} {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.target.value.trim() !== "") {
              handleChange([...tags, e.target.value.trim()]);
              e.target.value = "";
            }
          }}
        />
      )}
    />
  );
};

export default CustomList;
